import script from "./SecHero.vue?vue&type=script&setup=true&lang=js"
export * from "./SecHero.vue?vue&type=script&setup=true&lang=js"

import "./SecHero.vue?vue&type=style&index=0&id=1dc79795&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc79795"]])

export default __exports__